module.exports = __webpack_public_path__ + "OpenSans-Italic.b209aeb4264cce6c75fd.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Italic.woff2
// module id = ../../../../../src/assets/customfonts/OpenSans-Italic.woff2
// module chunks = styles